import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import { getAttendance, checkinToday, faceCheckin, antiIdle, unCheckinToday } from './attendance.actions';
import { getMembers, getMember } from '../members/members.actions';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { getPrograms } from '../programs/Actions';
import { getPackages } from '../mms-package/Actions';
import AttendanceCheckInComponent from './AttendanceCheckInComponent';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    getAttendance: (year: number, month: number) => dispatch(getAttendance(year, month)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toDashboard: () => dispatch(push(paths.dashboard)),
    checkinToday: (
      memberId: string, 
      programId: number,
      accountId?: number,
      packageId?: number,
      noShow?: boolean
    ) => dispatch(checkinToday(
      memberId, 
      programId,
      accountId,
      packageId,
      noShow
    )),
    unCheckinToday: (memberId: string, time: number) => dispatch(unCheckinToday(memberId, time)),
    getMembers: () => dispatch(getMembers()),
    getMember: (memberId: number) => dispatch(getMember(memberId)),
    faceCheckin: (file: File, programId: number) => dispatch(faceCheckin(file, programId)),
    getPrograms: () => dispatch(getPrograms()),
    antiIdle: () => dispatch(antiIdle()),
    getPackages: () => dispatch(getPackages())
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    programsState: state.programsState,
    attendanceState: state.attendanceState,
    checkinState: state.checkinState,
    membersState: state.membersState,
    businessState: state.businessState,
    packageState: state.packageState
  };
};

const AttendanceCheckIn = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AttendanceCheckInComponent);

export default AttendanceCheckIn;


// WEBPACK FOOTER //
// ./src/attendance/AttendanceCheckIn.tsx